module.exports = {
          srcSet: __webpack_public_path__ + "public/images/63f9ab4d353bbf1d059e79fbe0fcf86b-1536.jpg"+" 1536w",
          images:[ {path: __webpack_public_path__ + "public/images/63f9ab4d353bbf1d059e79fbe0fcf86b-1536.jpg",width: 1536,height: 1024}],
          src: __webpack_public_path__ + "public/images/63f9ab4d353bbf1d059e79fbe0fcf86b-1536.jpg",
          toString:function(){return __webpack_public_path__ + "public/images/63f9ab4d353bbf1d059e79fbe0fcf86b-1536.jpg"},
          
          width: 1536,
          height: 1024
        }